import serverInterface from 'server-interface';

import externalEventCodes from 'event-system/codes/external';

import {
  findIndexByPropertyValue,
  filterByPropertyValueBasic
} from 'utilities/collection';

class FormsManager {

  constructor(application) {

    this.initialized = false;
    this.loaded = false;
    this.collection = [];

    this.application = application;

  }

  async initialize(bootstrapData) {

    this.registerEventHandlers();

    this.initialized = true;

  }

  tryAdd(item) {

    const itemIndex = findIndexByPropertyValue(this.collection, '_id', item._id);

    if (itemIndex !== -1) {
      return;
    }

    this.collection.push(item);

  }

  tryRemove(itemId) {

    const itemIndex = findIndexByPropertyValue(this.collection, '_id', itemId);

    if (itemIndex === -1) {
      return;
    }

    this.collection.splice(itemIndex, 1);

  }

  handleCreatedEvent(payload) {

    this.tryAdd(payload.form);

  }

  handleUpdatedEvent(payload) {

    this.tryRemove(payload.form._id);
    this.tryAdd(payload.form);

  }

  handleDeletedEvent(payload) {

    this.tryRemove(payload.form._id);

  }

  registerEventHandlers() {

    this.application.eventSystem.internal.on(externalEventCodes.FORM_CREATED, this.handleCreatedEvent.bind(this));
    this.application.eventSystem.internal.on(externalEventCodes.FORM_UPDATED, this.handleUpdatedEvent.bind(this));
    this.application.eventSystem.internal.on(externalEventCodes.FORM_DELETED, this.handleDeletedEvent.bind(this));

  }

  async loadAll() {

    if (this.loaded === true) {
      return;
    }

    const queryOptions = {
      projection: ['_id', 'name', 'attemptToCreateContactOnSubmission'],
      filterOptions: {}
    };

    this.collection = await serverInterface.startup.forms.getFormsByQueryOptions(queryOptions);

    this.loaded = true;

  }

  getAll() {

    return structuredClone(this.collection);

  }

  getFormsThatCanCreateContacts() {

    const forms = this.getAll();

    return filterByPropertyValueBasic(forms, 'attemptToCreateContactOnSubmission', true);

  }

  isExistsById(itemId) {

    const itemIndex = findIndexByPropertyValue(this.collection, '_id', itemId);

    return itemIndex !== -1;

  }

  async create(payload) {

    let item = await serverInterface.startup.forms.createForm(payload);

    this.tryAdd(item);

    return item;

  }

  async delete(itemId) {

    await serverInterface.startup.forms.deletePromotionCode(itemId);

    this.tryRemove(itemId);

  }

}

export default FormsManager;